import { delegate } from 'lib/helpers';

export default function fieldFocusBlurEvents() {
  delegate({
    wrapperEl: document,
    eventName: 'focus',
    delegatedElClass: 'ez-input__field',
    action: (event:Event) => {
      const target = event.target as HTMLElement;

      if (!target.hasAttribute('readonly')) {
        const inputWrap = target.closest('.ez-input');
        inputWrap.classList.add('is-focused');
      }
    },
    useCapture: true,
  });

  delegate({
    wrapperEl: document,
    eventName: 'blur',
    delegatedElClass: 'ez-input__field',
    action: (event:Event) => {
      const target = event.target as HTMLElement;

      if (!target.hasAttribute('readonly')) {
        const inputWrap = target.closest('.ez-input');

        // NOT an animated field, remove focus on blur
        if (!inputWrap.classList.contains('ez-input--animated-label')) {
          inputWrap.classList.remove('is-focused');
        }
      }
    },
    useCapture: true,
  });
}

(() => {
  fieldFocusBlurEvents();
})();
